
const DepressionAssessmentResultFormat = ({
   data,
    companyName = "Mento",
    companyLogo = "https://i.postimg.cc/RvWYycTG/mento-Logo-ICON.png",
  }) => {
    const getDepressionLevel = (score) => {
      if (score <= 10) return "Normal Mood Fluctuations";
      if (score <= 16) return "Mild Mood Disturbance";
      if (score <= 20) return "Borderline Clinical Depression";
      if (score <= 30) return "Moderate Depression";
      if (score <= 40) return "Severe Depression";
      return "Extreme Depression";
    };
  
    const level = getDepressionLevel(data.score);
  
    return (
      <div
        style={{
          fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
          maxWidth: "600px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          color: "#333",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 5px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
            padding: "30px 20px",
            textAlign: "center",
            color: "white",
          }}
        >
          <img
            src={companyLogo}
            alt={companyName}
            style={{
              maxHeight: "60px",
              marginBottom: "15px",
            }}
          />
          <h1 style={{ fontSize: "26px", fontWeight: "600", margin: "0" }}>
            Your Depression Assessment Result
          </h1>
          <p style={{ fontSize: "16px", marginTop: "10px" }}>
            Here’s What to Do Next
          </p>
        </div>
  
        {/* Message */}
        <div style={{ padding: "30px 40px" }}>
          <p style={{ fontSize: "17px", lineHeight: "1.6" }}>
            Hi <span style={{ fontWeight: "600", color: "#6a11cb" }}>{data.fullName}</span>,
          </p>
  
          <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
            Thank you for completing Mento’s Depression (BDI) Assessment. Based on your responses, we’ve outlined your score and some personalized next steps to help you move forward with care and clarity.
          </p>
  
          <p style={{ fontSize: "16px", lineHeight: "1.6", fontWeight: "600", marginTop: "20px" }}>
            📊 Your Depression Level: {data.score} ({level})
          </p>
  
          {/* Guidance Section */}
          <div style={{ marginTop: "20px" }}>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7", fontSize: "15px" }}>
              <li><strong>1–10:</strong> Normal Mood Fluctuations – Continue practicing self-care and staying connected.</li>
              <li><strong>11–16:</strong> Mild Mood Disturbance – Small changes and conversations can help.</li>
              <li><strong>17–20:</strong> Borderline Clinical Depression – We recommend speaking with a therapist.</li>
              <li><strong>21–30:</strong> Moderate Depression – Therapy is advised to address your emotional needs.</li>
              <li><strong>31–40:</strong> Severe Depression – You’re not alone. Please consider booking a session soon.</li>
              <li><strong>41+:</strong> Extreme Depression – Support is urgent. Reach out immediately.</li>
            </ul>
          </div>
  
          <p style={{ marginTop: "20px", fontSize: "16px", lineHeight: "1.6" }}>
            💙 We’re here for you. Your emotions are valid, and help is always available. Our experts offer a safe, confidential space to talk and heal.
          </p>
  
          {/* CTA */}
          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <a
              href="https://wa.me/+919120719120"
              style={{
                background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
                color: "#ffffff",
                padding: "12px 26px",
                borderRadius: "30px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
              }}
            >
              Book a Session or Chat With Us
            </a>
          </div>
        </div>
      </div>
    );
  };



  const AnxietyAssessmentResultFormat = ({
   data,
    companyName = "Mento",
    companyLogo = "https://i.postimg.cc/RvWYycTG/mento-Logo-ICON.png",
  }) => {
    const getAnxietyLevel = (score) => {
      if (score <= 4) return "Minimal Anxiety";
      if (score <= 9) return "Mild Anxiety";
      if (score <= 14) return "Moderate Anxiety";
      return "Severe Anxiety";
    };
  
    const level = getAnxietyLevel(data.score);
  
    return (
      <div
        style={{
          fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
          maxWidth: "600px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          color: "#333",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 5px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
            padding: "30px 20px",
            textAlign: "center",
            color: "white",
          }}
        >
          <img
            src={companyLogo}
            alt={companyName}
            style={{ maxHeight: "60px", marginBottom: "15px" }}
          />
          <h1 style={{ fontSize: "26px", fontWeight: "600", margin: "0" }}>
            Your Anxiety Assessment Result
          </h1>
          <p style={{ fontSize: "16px", marginTop: "10px" }}>
            Here’s What to Do Next
          </p>
        </div>
  
        {/* Message */}
        <div style={{ padding: "30px 40px" }}>
          <p style={{ fontSize: "17px", lineHeight: "1.6" }}>
            Hi <span style={{ fontWeight: "600", color: "#ee0979" }}>{data.fullName}</span>,
          </p>
  
          <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
            Thank you for taking the time to complete Mento’s Anxiety Self-Assessment. Based on your responses, we’ve prepared your personalized result and guidance below.
          </p>
  
          <p style={{ fontSize: "16px", lineHeight: "1.6", fontWeight: "600", marginTop: "20px" }}>
            📊 Your Anxiety Level: {data.score} ({level})
          </p>
  
          {/* Guidance Section */}
          <div style={{ marginTop: "20px" }}>
            <p style={{ fontWeight: "600", marginBottom: "5px" }}>💡 What this means:</p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7", fontSize: "15px" }}>
              <li>
                <strong>0–4 (Minimal Anxiety):</strong> Your responses indicate minimal signs of anxiety. Maintain healthy habits and self-care. We’re always here if you need to talk.
              </li>
              <li>
                <strong>5–9 (Mild Anxiety):</strong> Occasional worry or restlessness may be present. Mindfulness, journaling, or talking to someone can help. If this continues, a short therapy session may be helpful.
              </li>
              <li>
                <strong>10–14 (Moderate Anxiety):</strong> Anxiety may be interfering with sleep or focus. It’s a good time to speak with a therapist about helpful tools and techniques.
              </li>
              <li>
                <strong>15–21 (Severe Anxiety):</strong> You’re likely feeling persistent anxiety or distress. Please know you're not alone. We recommend you schedule a session with a professional soon.
              </li>
            </ul>
          </div>
  
          {/* Support message */}
          <p style={{ marginTop: "20px", fontSize: "16px", lineHeight: "1.6" }}>
            💙 You’re not alone. Your feelings are valid. Our licensed therapists are here to guide you in a safe, confidential space—anytime you need support.
          </p>
  
          {/* CTA */}
          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <a
              href="https://wa.me/+919120719120"
              style={{
                background: "linear-gradient(90deg, #ff6a00 0%, #ee0979 100%)",
                color: "#ffffff",
                padding: "12px 26px",
                borderRadius: "30px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
              }}
            >
              📅 Book a Session Now
            </a>
          </div>
  
          {/* Closing */}
          <p style={{ marginTop: "30px", textAlign: "center", fontSize: "15px" }}>
            Take care,<br />
            <strong>Team {companyName} 💙</strong>
          </p>
        </div>
      </div>
    );
  };
  
  const WellbeingAssessmentResultFormat = ({
    data,
    companyName = "Mento",
    companyLogo = "https://i.postimg.cc/RvWYycTG/mento-Logo-ICON.png",
  }) => {
    

    const getDistressLevel = (score) => {
      if (score <= 4) return "None to Minimal Distress";
      if (score <= 9) return "Mild Distress";
      if (score <= 14) return "Moderate Distress";
      if (score <= 19) return "Moderately Severe Distress";
      return "Severe Distress";
    };
  
    const level = getDistressLevel(data.score);
  
    return (
      <div
        style={{
          fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
          maxWidth: "600px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          color: "#333",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 5px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)",
            padding: "30px 20px",
            textAlign: "center",
            color: "white",
          }}
        >
          <img
            src={companyLogo}
            alt={companyName}
            style={{ maxHeight: "60px", marginBottom: "15px" }}
          />
          <h1 style={{ fontSize: "26px", fontWeight: "600", margin: "0" }}>
            Your Self-Assessment Result
          </h1>
          <p style={{ fontSize: "16px", marginTop: "10px" }}>
            Here’s What to Do Next
          </p>
        </div>
  
        {/* Message */}
        <div style={{ padding: "30px 40px" }}>
          <p style={{ fontSize: "17px", lineHeight: "1.6" }}>
            Hi <span style={{ fontWeight: "600", color: "#0072ff" }}>{data.fullName}</span>,
          </p>
  
          <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
            Thank you for completing Mento’s Self-Assessment Test. Based on your responses, we’ve summarized your result below, along with some helpful next steps to support your emotional well-being.
          </p>
  
          <p style={{ fontSize: "16px", fontWeight: "600", marginTop: "20px" }}>
            📊 Your Well-being Score: {data.score} ({level})
          </p>
  
          {/* Guidance Section */}
          <div style={{ marginTop: "20px" }}>
            <p style={{ fontWeight: "600", marginBottom: "5px" }}>💡 What this means and what you can do:</p>
            <ul style={{ paddingLeft: "20px", lineHeight: "1.7", fontSize: "15px" }}>
              <li>
                <strong>0–4 (None to Minimal Distress):</strong> You’re showing signs of emotional stability. Keep up the rest, routines, and self-care. Mento is here if things feel heavy at any point.
              </li>
              <li>
                <strong>5–9 (Mild Distress):</strong> Occasional stress is normal. Try mindfulness, breathing exercises, or talking to someone. If feelings persist, a short therapy session may help.
              </li>
              <li>
                <strong>10–14 (Moderate Distress):</strong> You might be facing consistent emotional challenges. A therapist can help you uncover causes and build coping strategies. Consider scheduling a session.
              </li>
              <li>
                <strong>15–19 (Moderately Severe Distress):</strong> Feeling overwhelmed or stuck? You’re not alone. Professional support can really help during this time.
              </li>
              <li>
                <strong>20+ (Severe Distress):</strong> This score shows signs of significant emotional distress. Please seek professional support—you don’t have to carry this alone. Mento’s experts are here for you.
              </li>
            </ul>
          </div>
  
          {/* Support message */}
          <p style={{ marginTop: "20px", fontSize: "16px", lineHeight: "1.6" }}>
            💙 You're Not Alone. Help is available and healing is possible. Our experts are here for a confidential session whenever you're ready.
          </p>
  
          {/* CTA */}
          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <a
              href="https://wa.me/+919120719120"
              style={{
                background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
                color: "#ffffff",
                padding: "12px 26px",
                borderRadius: "30px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
              }}
            >
              📅 Book a Session Now
            </a>
          </div>
  
          {/* Closing */}
          <p style={{ marginTop: "30px", textAlign: "center", fontSize: "15px" }}>
            Take care,<br />
            <strong>Team {companyName} 💙</strong>
          </p>
        </div>
      </div>
    );
  };

  const ToolResponsetoMentoFormat =({ data={},
     companyName = "Mento",
  companyLogo = "https://i.postimg.cc/RvWYycTG/mento-Logo-ICON.png"

  })=>{
    const formatValue = (value) => {
        if (typeof value === "object" && value !== null) {
          return (
            <pre
              style={{
                backgroundColor: "#f9f9f9",
                padding: "10px",
                borderRadius: "4px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontSize: "13px",
              }}
            >
              {JSON.stringify(value, null, 2)}
            </pre>
          );
        }
        return String(value);
      };
    
      return (
        <div
          style={{
            fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
            maxWidth: "600px",
            margin: "0 auto",
            backgroundColor: "#ffffff",
            color: "#333333",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "linear-gradient(135deg, #00b09b 0%, #96c93d 100%)",
              padding: "20px",
              textAlign: "center",
              color: "white",
            }}
          >
            <img
              src={companyLogo}
              alt={companyName}
              style={{ maxHeight: "50px", marginBottom: "10px" }}
            />
            <h1 style={{ fontSize: "24px", margin: "5px 0", fontWeight: "600" }}>
              New Form Submission
            </h1>
          </div>
    
          {/* Body */}
          <div style={{ padding: "25px" }}>
            <p style={{ fontSize: "16px", lineHeight: "1.5", marginTop: "0" }}>
            New assessment submission received. Here are the details:

            </p>
    
            <div
              style={{
                backgroundColor: "#f0fdf4",
                padding: "20px",
                borderRadius: "8px",
                margin: "20px 0",
                boxShadow: "0 2px 5px rgba(0, 176, 155, 0.1)",
                borderLeft: "4px solid #00b09b",
              }}
            >
              <h3
                style={{
                  margin: "0 0 15px 0",
                  color: "#00b09b",
                  fontSize: "18px",
                }}
              >
                Submission Details
              </h3>
    
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {Object.entries(data).map(([key, value], index) => (
                    <tr key={index}>
                      <td
                        style={{
                          padding: "10px",
                          fontWeight: "600",
                          width: "35%",
                          verticalAlign: "top",
                          textTransform: "capitalize",
                        }}
                      >
                        {key.replace(/([A-Z])/g, " $1")}:
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          backgroundColor: "white",
                          borderRadius: "4px",
                          wordBreak: "break-word",
                        }}
                      >
                        {formatValue(value)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
    
            {/* Action Button */}
            {data.email && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                  margin: "25px 0",
                }}
              >
                <a
                  href={`mailto:${data.email}?subject=Regarding%20Your%20${companyName}%20Consultation%20Request`}
                  style={{
                    background: "#00b09b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "4px",
                    textDecoration: "none",
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                >
                  Contact User
                </a>
              </div>
            )}
    
            {/* Note */}
            <div
              style={{
                backgroundColor: "#f5f5f5",
                padding: "15px",
                borderRadius: "6px",
                fontSize: "14px",
                marginTop: "20px",
              }}
            >
              <p style={{ margin: "0", lineHeight: "1.5" }}>
                To access the full submission details and take necessary actions,
                please log in to your admin dashboard.
              </p>
            </div>
    
            {/* Footer */}
            <div
              style={{
                borderTop: "1px solid #e1e1e1",
                paddingTop: "20px",
                marginTop: "25px",
                textAlign: "center",
                color: "#666666",
                fontSize: "13px",
              }}
            >
              <p style={{ margin: "0 0 10px 0" }}>
                This is an automated notification. Please do not reply to this
                email.
              </p>
            </div>
          </div>
        </div>
      );
  };

  




 export {DepressionAssessmentResultFormat ,AnxietyAssessmentResultFormat ,WellbeingAssessmentResultFormat,ToolResponsetoMentoFormat

 }